import { isDisposalPaymentFeatureEnabled } from 'constant';
import { article_order_status, offer_step } from 'constant/static';

/** Sözleşmenin Sipariş ve Telif adımında da açılabildiği statüler (yeniden telif / ret akışında sözleşme erken oluşur). */
const CONTRACT_STATUSES = [
  article_order_status['Telif Sonrasi'],
  article_order_status['IH-Madde Kontrol Yeniden Telif'],
  article_order_status.Onaylandı,
  article_order_status.Reddedildi,
];

/**
 * Tasarruf sözleşmesi / ödeme bilgileri erişiminin maddenin sürecine göre açık olup olmadığı. Rol kontrolü çağırandadır.
 *
 * BE sözleşme uçlarında statü kısıtı yoktur; sözleşme telif sonrasına girişte oluşur
 * (`ArticleOfferListener::startDisposalContract`). Bayrak açıkken Telif Sonrası'nın tüm alt aşamaları
 * ve Yayın adımı da kapsanır; kapalıyken eski statü listesi korunur.
 */
export const isSavingContractAvailable = (offer) => {
  if (CONTRACT_STATUSES.includes(offer.status)) return true;
  return isDisposalPaymentFeatureEnabled && offer.step >= offer_step.POST_ORDER;
};
